import { Modal } from 'antd';
import { messages } from 'src/constants/messages';

function ModalDeleteConfirmHoTro(actionDelete) {
  Modal.confirm({
    title: messages.MODAL_DELETE_TITLE,
    content: messages.MODAL_DELETE_CONTENT,
    onOk(e) {
      e();
      actionDelete();
    },
    okText: messages.MODAL_CONFIRM_OK,
    onCancel() { },
    cancelText: messages.MODAL_CONFIRM_CANCEL
  });
}

export default ModalDeleteConfirmHoTro;
